import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs';

import { TranslationService } from '../../../shell/translation-service';
import { ConflictIndicator } from '../../shared/components/conflict-indicator/conflict-indicator';
import { findNavItem } from '../nav-items';

@Component({
  selector: 'ima-module-header',
  imports: [ConflictIndicator],
  templateUrl: './module-header.html',
  styleUrl: './module-header.scss',
})
export class ModuleHeader {
  readonly criticalStockCount = input(0);

  readonly reportedConflictsCount = input(0);

  protected readonly i18n = inject(TranslationService);

  private readonly router = inject(Router);

  private readonly currentUrl = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: this.router.url },
  );

  protected readonly title = computed(() => {
    const item = findNavItem(this.currentUrl());

    return item ? this.i18n.t(item.labelKey) : '';
  });
}
